import { render, staticRenderFns } from "./PickUpDesktop.vue?vue&type=template&id=853a5036&"
import script from "./PickUpDesktop.vue?vue&type=script&lang=js&"
export * from "./PickUpDesktop.vue?vue&type=script&lang=js&"
import style0 from "./PickUpDesktop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports